module.exports = __webpack_public_path__ + "img/logo2.f03f2dcd.png";